import React from 'react';
import ContentLoader from 'react-content-loader';

const LoaderList = props => (
	<ContentLoader height={160} speed={2} primaryColor="#f3f3f3" secondaryColor="#dcdcdc" {...props}>
		<circle cx="10" cy="20" r="8" />
		<rect x="25" y="15" rx="3" ry="3" width="100%" height="10" />
		<circle cx="10" cy="50" r="8" />
		<rect x="25" y="45" rx="3" ry="3" width="100%" height="10" />
		<circle cx="10" cy="80" r="8" />
		<rect x="25" y="75" rx="3" ry="3" width="100%" height="10" />
		<circle cx="10" cy="110" r="8" />
		<rect x="25" y="105" rx="3" ry="3" width="100%" height="10" />
		<circle cx="10" cy="140" r="8" />
		<rect x="25" y="135" rx="3" ry="3" width="100%" height="10" />
	</ContentLoader>
);

export default LoaderList;
